import { useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import {
	AutocompleteInput,
	Filter,
	NumberInput,
	ReferenceInput,
	SelectInput,
	useTranslate,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import { usersConfig } from "../users";
import EventSelectInput from "./inputs/EventSelectInput";

const types = ["none", "referral"].map((id) => ({
	id,
	name: `resources.bookmaker-deals.type.${id}`,
}));

const Filters = (props) => {
	const translate = useTranslate();
	const theme = useTheme();
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	return (
		<Filter {...props} variant="outlined">
			<ReferenceInput
				source="bookmaker_type_id"
				reference="bookmaker-types"
				alwaysOn
				fullWidth
				style={{ marginTop: theme.spacing(4), minWidth: 180 }}
				allowEmpty
				emptyText="ra.action.all"
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				alwaysOn={!sm}
				filter={{ status: "active" }}
				fullWidth
				{...bookmakersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<ReferenceInput
				source="user_id"
				reference="users"
				alwaysOn={!sm}
				fullWidth
				{...usersConfig.reference}
			>
				<AutocompleteInput
					optionText="name"
					resettable
					emptyText={translate("resources.bookmaker-deals.fields.users.all")}
					alwaysOn
					fullWidth
				/>
			</ReferenceInput>
			<SelectInput
				allowEmpty
				emptyText="ra.action.all"
				source="type"
				choices={types}
				resettable
				alwaysOn
				fullWidth
			/>
			<EventSelectInput source="event_id" fullWidth />
			<NumberInput source="amount" fullWidth />
		</Filter>
	);
};
export default Filters;
